import styles from '@components/Progress/ProgressBar.styles';
type PropsType = {
  actualCount: number;
  maxCount: number;
};
const ProgressBar = ({
  actualCount,
  maxCount
}: PropsType) => <div sx={styles.progressBar(actualCount, maxCount)} />;
export default ProgressBar;